import React from "react";
import "./about.css";
import ME from "../../assets/about-me.png";

const About = () => {
  return (
    <section id="about">
      <h5>Get to Know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About" />
          </div>
        </div>
        <div className="about__content">
          <p>
            Bachelor of Information Systems graduate with hands-on experience in
            front-end and full-stack development. Proficient in HTML, CSS,
            JavaScript, React.js, TypeScript (React.ts), and responsive design
            principles. Experienced with back-end technologies including Node.js
            and Express.js. Completed a Full-Stack Web Developer bootcamp,
            developing a Movie App using React.js and Express.js. Passionate
            about building user-centric, scalable web applications with clean
            and maintainable code. Seeking opportunities as a Front-End
            Developer, Full-Stack Developer, or Back-End Developer.
          </p>
          <a
            href="https://www.linkedin.com/in/rohim48/"
            target="_blank"
            className="btn btn-primary"
            rel="noreferrer"
          >
            Linked In
          </a>
          <a
            href="https://github.com/itsArchi"
            target="_blank"
            className="btn btn-primary"
            rel="noreferrer"
          >
            GitHub
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
